module.exports = __webpack_public_path__ + "img/block-surprise.be9efa21.jpg";